import { computed, onMounted, watch } from "vue";
import { useRoute } from "vue-router";
import { useI18n } from 'vue-i18n';
import CookieUsage from "./auth/cookie_usage.vue";
import Header from "./header.vue";
import { eventBus, EVENTS } from "../event_bus";
export default {
  components: {
    CookieUsage,
    Header
  },
  props: {
    titleSubKey: String,
    headerTitleParams: {
      type: Object,
      default: {}
    }
  },
  created,

  setup(props, context) {
    const route = useRoute();
    const i18n = useI18n();

    const updateHeader = () => {
      const titleKey = props.titleSubKey && `.${props.titleSubKey}` || '';
      const title = i18n.t(`pages${titleKey}.${route.name}.title`, { ...route.params,
        ...props.headerTitleParams
      });
      document.title = title;
    };

    onMounted(updateHeader);
    watch(route, updateHeader);
    watch(props.headerTitleParams, updateHeader);
  }

};

function created() {
  document.body.addEventListener('click', e => eventBus.$emit(EVENTS.Body.Click, e));
  window.addEventListener('resize', e => eventBus.$emit(EVENTS.Window.Resize, e));
}